import IconApps from '@material-ui/icons/esm/Apps';

import { IconChannelAdobeExperienceManager } from 'src/assets/icons/channels/IconChannelAdobeExperienceManager';
import { IconChannelAmazon } from 'src/assets/icons/channels/IconChannelAmazon';
import { IconChannelBraze } from 'src/assets/icons/channels/IconChannelBraze';
import { IconChannelCompetitors } from 'src/assets/icons/channels/IconChannelCompetitors';
import { IconChannelEloqua } from 'src/assets/icons/channels/IconChannelEloqua';
import { IconChannelFacebookPages } from 'src/assets/icons/channels/IconChannelFacebookPages';
import { IconChannelGong } from 'src/assets/icons/channels/IconChannelGong';
import { IconChannelGoogle } from 'src/assets/icons/channels/IconChannelGoogle';
import { IconChannelHomepage } from 'src/assets/icons/channels/IconChannelHomepage';
import { IconChannelHubspot } from 'src/assets/icons/channels/IconChannelHubspot';
import { IconChannelInRiver } from 'src/assets/icons/channels/IconChannelInRiver';
import { IconChannelInstagram } from 'src/assets/icons/channels/IconChannelInstagram';
import { IconChannelIterable } from 'src/assets/icons/channels/IconChannelIterable';
import { IconChannelLandingPages } from 'src/assets/icons/channels/IconChannelLandingPages';
import { IconChannelLinkedin } from 'src/assets/icons/channels/IconChannelLinkedin';
import { IconChannelMarketo } from 'src/assets/icons/channels/IconChannelMarketo';
import { IconChannelMeta } from 'src/assets/icons/channels/IconChannelMeta';
import { IconChannelMicrosoftDynamics } from 'src/assets/icons/channels/IconChannelMicrosoftDynamics';
import { IconChannelOktopost } from 'src/assets/icons/channels/IconChannelOktopost';
import { IconChannelOutbrain } from 'src/assets/icons/channels/IconChannelOutbrain';
import { IconChannelOutreach } from 'src/assets/icons/channels/IconChannelOutreach';
import { IconChannelPinterest } from 'src/assets/icons/channels/IconChannelPinterest';
import { IconChannelProductPage } from 'src/assets/icons/channels/IconChannelProductPage';
import { IconChannelRevcontent } from 'src/assets/icons/channels/IconChannelRevcontent';
import { IconChannelSalesforce } from 'src/assets/icons/channels/IconChannelSalesforce';
import { IconChannelSalsify } from 'src/assets/icons/channels/IconChannelSalsify';
import { IconChannelSitecore } from 'src/assets/icons/channels/IconChannelSitecore';
import { IconChannelSprinklr } from 'src/assets/icons/channels/IconChannelSprinklr';
import { IconChannelTaboola } from 'src/assets/icons/channels/IconChannelTaboola';
import { IconChannelThoughtLeadership } from 'src/assets/icons/channels/IconChannelThoughtLeadership';
import { IconChannelTrustpilot } from 'src/assets/icons/channels/IconChannelTrustpilot';
import { IconChannelTwitter } from 'src/assets/icons/channels/IconChannelTwitter';
import { IconChannelVerizon } from 'src/assets/icons/channels/IconChannelVerizon';
import { IconChannelWord } from 'src/assets/icons/channels/IconChannelWord';
import { IconChannelWrike } from 'src/assets/icons/channels/IconChannelWrike';
import { IconChannelWTM } from 'src/assets/icons/channels/IconChannelWTM';
import { IconChannelYoutube } from 'src/assets/icons/channels/IconChannelYoutube';
import { PerfectHeadline } from 'src/assets/icons/generationTools/PerfectHeadline';
import { IconCSV } from 'src/assets/icons/IconCSV';
import { IconDocument } from 'src/assets/icons/IconDocument';
import { IconEmail } from 'src/assets/icons/IconEmail';
import { IconResourceTypeUrl } from 'src/assets/icons/ResourceTypeUrl';
import {
  BETA_CHANNEL,
  EMAILS_CHANNEL,
  EXPORT_CHANNEL,
  EXTERNAL_CHANNEL,
  NATIVE_CHANNEL,
  PLATFORM_CHANNEL,
  REVIEWS_CHANNEL,
  SOCIAL_CHANNEL,
  WEBSITE_CHANNEL,
} from 'src/data/channel';
import { isEmailCsvResourceDocument, RESOURCE_DOCUMENT } from 'src/data/performance';

export function pickChannelIcon(channel) {
  if (channel === SOCIAL_CHANNEL.facebook) {
    return IconChannelMeta;
  }
  if (channel === SOCIAL_CHANNEL.instagram) {
    return IconChannelInstagram;
  }
  if ([SOCIAL_CHANNEL.linkedin, SOCIAL_CHANNEL.linkedinSocial].includes(channel)) {
    return IconChannelLinkedin;
  }
  if ([SOCIAL_CHANNEL.twitter, SOCIAL_CHANNEL.twitterSocial].includes(channel)) {
    return IconChannelTwitter;
  }
  if (channel === SOCIAL_CHANNEL.google) {
    return IconChannelGoogle;
  }
  if (channel === SOCIAL_CHANNEL.youtube) {
    return IconChannelYoutube;
  }
  if (channel === SOCIAL_CHANNEL.pinterest) {
    return IconChannelPinterest;
  }
  if (channel === NATIVE_CHANNEL.taboola) {
    return IconChannelTaboola;
  }
  if (channel === NATIVE_CHANNEL.outbrain) {
    return IconChannelOutbrain;
  }
  if (channel === NATIVE_CHANNEL.revcontent) {
    return IconChannelRevcontent;
  }
  if (channel === NATIVE_CHANNEL.verizon) {
    return IconChannelVerizon;
  }
  if (channel === REVIEWS_CHANNEL.trustpilot) {
    return IconChannelTrustpilot;
  }
  if (channel === REVIEWS_CHANNEL.amazon) {
    return IconChannelAmazon;
  }
  if (channel === WEBSITE_CHANNEL.homepage) {
    return IconChannelHomepage;
  }
  if (channel === WEBSITE_CHANNEL.landingPage) {
    return IconChannelLandingPages;
  }
  if (channel === WEBSITE_CHANNEL.competitors) {
    return IconChannelCompetitors;
  }
  if (channel === WEBSITE_CHANNEL.thoughtLeadership) {
    return IconChannelThoughtLeadership;
  }
  if (channel === WEBSITE_CHANNEL.productPage) {
    return IconChannelProductPage;
  }
  if (channel === WEBSITE_CHANNEL.other) {
    return IconResourceTypeUrl;
  }
  if (channel === EMAILS_CHANNEL.hubspot) {
    return IconChannelHubspot;
  }
  if (
    [
      EMAILS_CHANNEL.salesforce,
      EMAILS_CHANNEL.salesforceExactTarget,
      EXTERNAL_CHANNEL.salesforceCrm,
      EXPORT_CHANNEL.salesforceExport,
    ].includes(channel)
  ) {
    return IconChannelSalesforce;
  }
  if (channel === EMAILS_CHANNEL.marketo) {
    return IconChannelMarketo;
  }
  if (channel === EMAILS_CHANNEL.braze) {
    return IconChannelBraze;
  }
  if (channel === EMAILS_CHANNEL.eloqua) {
    return IconChannelEloqua;
  }
  if (channel === EMAILS_CHANNEL.iterable) {
    return IconChannelIterable;
  }
  if (channel === SOCIAL_CHANNEL.facebookPages) {
    return IconChannelFacebookPages;
  }
  if (
    isEmailCsvResourceDocument(channel) ||
    channel === RESOURCE_DOCUMENT.emailCsvResource ||
    channel === PLATFORM_CHANNEL.emailChannel
  ) {
    return IconEmail;
  }
  if (channel === RESOURCE_DOCUMENT.googleDocs) {
    return IconDocument;
  }
  if (channel === PLATFORM_CHANNEL.projectWtm) {
    return IconChannelWTM;
  }
  if (channel === PLATFORM_CHANNEL.blogUrls) {
    return PerfectHeadline;
  }
  if (channel === PLATFORM_CHANNEL.generalDocument) {
    return IconDocument;
  }
  if (channel === BETA_CHANNEL.gong) {
    return IconChannelGong;
  }
  if (channel === BETA_CHANNEL.oktopost) {
    return IconChannelOktopost;
  }
  if (channel === BETA_CHANNEL.adobeExperienceManager) {
    return IconChannelAdobeExperienceManager;
  }
  if (channel === BETA_CHANNEL.outreach) {
    return IconChannelOutreach;
  }
  if (channel === BETA_CHANNEL.salsify) {
    return IconChannelSalsify;
  }
  if (channel === BETA_CHANNEL.microsoftWord) {
    return IconChannelWord;
  }
  if (channel === BETA_CHANNEL.sprinklr || channel === EXPORT_CHANNEL.sprinklrExport) {
    return IconChannelSprinklr;
  }
  if (channel === BETA_CHANNEL.inriver) {
    return IconChannelInRiver;
  }
  if (channel === BETA_CHANNEL.sitecore) {
    return IconChannelSitecore;
  }
  if (channel === BETA_CHANNEL.wrike) {
    return IconChannelWrike;
  }
  if (channel === EXTERNAL_CHANNEL.microsoftDynamicsSales) {
    return IconChannelMicrosoftDynamics;
  }
  if (channel === EXPORT_CHANNEL.csvExport) {
    return IconCSV;
  }

  return IconApps;
}
